@if (installPrompt && !(ui.isInstallPromptDismissed$ | async)) {
  <div
    [@enterFromBottom]
    [class]="
      (enable365 ? 'sideBackgroundNyboligMain nybolig-theme' : 'bg-orange') +
      ' text-white text-start pwa-install-label p-3 shadow-sm'
    "
  >
    <div class="row">
      <div class="col-auto flex items-center" role="button" (click)="install()">
        <span class="inline-flex">
          <igntr-icon name="bookmarkPlus" [size]="40"></igntr-icon>
        </span>
      </div>
      <div class="col" role="button" (click)="install()">
        <p class="m-0" i18n="Label to install app">
          {{ "install" | transloco }}
        </p>
        <small i18n="Button allow offline using">{{
          "useOffline" | transloco
        }}</small>
      </div>
      <div class="col-auto p-0">
        <div class="vr h-100"></div>
      </div>
      <div
        class="col-auto text-center"
        role="button"
        (click)="ui.dismissInstallPrompt()"
      >
        <p class="m-0 flex items-center justify-center">
          <span class="inline-flex">
            <igntr-icon name="close" [size]="20"></igntr-icon>
          </span>
        </p>
        <small i18n="Button to dismiss installation">{{
          "dismiss" | transloco
        }}</small>
      </div>
    </div>
  </div>
}
